import { ChangeEvent, useEffect, useState } from 'react';

import { IWidgetCategoriesList } from '@entities/widget-card/model/types';

export const useInvoiceFields = ({
    isModalOpen,
    activePeriodPicked,
    paymentContext,
}: {
    isModalOpen: boolean;
    activePeriodPicked: number;
    paymentContext?: IWidgetCategoriesList['context'];
}) => {
    const [companyName, setCompanyName] = useState('');
    const [innKpp, setInnKpp] = useState('');

    const handleCompanyNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        setCompanyName(e.target.value);
    };
    const handleInnKppChange = (e: ChangeEvent<HTMLInputElement>) => {
        setInnKpp(e.target.value);
    };

    useEffect(() => {
        if (!isModalOpen) return;

        setInnKpp(paymentContext?.innKpp ?? '');
        setCompanyName(paymentContext?.companyName ?? '');
    }, [isModalOpen, paymentContext]);

    const onInvoiceHandler = () => {
        const params = new URLSearchParams({
            w: String(activePeriodPicked),
            company_name: companyName ?? '',
            inn_kpp: innKpp ?? '',
            not_my_company: paymentContext?.notMyCompany ? '1' : '0',
        });

        const url = `/payment/widget-plan/generate-invoice?${params.toString()}`;
        window.open(url, '_blank');
    };

    return {
        companyName,
        innKpp,
        handleCompanyNameChange,
        handleInnKppChange,
        onInvoiceHandler,
    };
};
